import { PayoutCard } from './PayoutCard';

/** A titled section of payout cards. Renders nothing when there are no payouts. */
export function PayoutList({ title, payouts }) {
  if (!payouts || payouts.length === 0) return null;

  return (
    <section>
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
        <span className="text-xs text-slate-500">
          {payouts.length} payout{payouts.length === 1 ? '' : 's'}
        </span>
      </div>
      <div className="space-y-3">
        {payouts.map((payout, index) => (
          <PayoutCard key={payout.id || payout.orderId || index} payout={payout} />
        ))}
      </div>
    </section>
  );
}

export default PayoutList;
